import React from 'react'

const PatientBody = () => {
    return (
        <div className="patients bg-blue-400 flex-1">
            
        </div>
    )
}

export default PatientBody
